import React from 'react';
import { motion } from 'framer-motion';
import { HiUser, HiExternalLink, HiPlay } from 'react-icons/hi';
import { images } from '../../constants';
import { parseMarkdown } from '../../utils/markdownUtils';
import { extractUrls, isYouTubeVideo, getYouTubeVideoId } from '../../utils/urlUtils';

const MessageItem = ({ message, userInfo }) => {
  return (
    <motion.div
      className={`app__ask-ai-message ${message.isAI ? 'ai' : 'user'}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {message.isAI ? (
        <img src={images.faceLogo} alt="Lovish" style={{ width: '40px', objectFit: 'cover' }} />
      ) : (
        <div className="message-avatar">
          <HiUser />
          {userInfo.name && (
            <span className="user-name">{userInfo.name.split(' ')[0]}</span>
          )}
        </div>
      )}
      <div className="message-content">
        {message.isStreaming && !message.text ? (
          <div className="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        ) : (
          <div
            className="message-text"
            dangerouslySetInnerHTML={{ __html: parseMarkdown(message.text) }}
          />
        )}
        <div className="message-time">{message.timestamp}</div>
        
        {/* Link previews */}
        {extractUrls(message.text).map((url, index) => (
          <div key={index} className="link-preview">
            {isYouTubeVideo(url) ? (
              <div className="youtube-preview">
                <div className="youtube-thumbnail">
                  <img 
                    src={`https://img.youtube.com/vi/${getYouTubeVideoId(url)}/mqdefault.jpg`} 
                    alt="YouTube thumbnail"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="youtube-play-overlay">
                    <HiPlay />
                  </div>
                </div>
                <div className="youtube-info">
                  <div className="youtube-title">YouTube Video</div>
                  <a 
                    href={url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="youtube-link"
                  >
                    <HiExternalLink />
                    Watch on YouTube
                  </a>
                </div>
              </div>
            ) : (
              <div className="url-preview">
                <HiExternalLink />
                <a 
                  href={url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="url-link"
                >
                  {url}
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default MessageItem; 